import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { setCalendarLoadState } from '../actions/internalActions';
import { removeCalendarFromCalendarsCache } from 'owa-calendar-cache';

mutator(setCalendarLoadState, actionMessage => {
    const { calendarId, loadState } = actionMessage;
    getStore().calendarIdsLoadState.set(calendarId, loadState);
});

mutator(removeCalendarFromCalendarsCache, actionMessage => {
    const { calendar } = actionMessage;
    getStore().calendarIdsLoadState.delete(calendar.id.id);
});
